import {
    Box,
    Typography
} from '@mui/material';

import { QRCodeCanvas } from 'qrcode.react';

const HINT_FONT_SIZE = 9;

interface QRCodeWithHintProps {
    qrUrl: string;
    locationName?: string;
    propertyName?: string;
}
const SUPPORT_EMAIL_ADDRESS = "support@tenerapro.com";
const PHONE_NUMBER = "(416) 400-3242";

const QRCodeWithHint = ({ qrUrl, locationName, propertyName }: QRCodeWithHintProps) => {

    return (
        <Box position="relative">
            <Box width="100%">
                <Box display="grid" gap={0.5} gridTemplateColumns="1fr 0.65fr" width="100%" bgcolor="white">
                    <Box textAlign="right" display="flex" flexDirection="column">
                        <img src={`${process.env.PUBLIC_URL}/Tenera-AI-Logo.jpg`} alt="Tenera AI Logo" style={{ objectFit: "contain", width: "100%" }} />
                        <Box display="flex" flexDirection="column">
                            <Typography variant="caption" sx={{ fontSize: 12, textAlign: "left" }} fontWeight={500}>
                                Email: {SUPPORT_EMAIL_ADDRESS}
                            </Typography>
                            <Typography variant="caption" sx={{ fontSize: 12, textAlign: "left" }} fontWeight={500}>
                                Phone: {PHONE_NUMBER}
                            </Typography>
                        </Box>
                    </Box>
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <QRCodeCanvas
                            value={qrUrl}
                            size={1024}
                            level='H'
                            style={{ objectFit: "contain", width: "100%", minWidth: 0, minHeight: 0, aspectRatio: "1/1", height: "unset important!" }}
                        />
                        <Box display="flex" flexDirection="column" width="100%" justifyContent="space-around" flex={1}>
                            {locationName && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        wordWrap: "break-word",
                                        display: "-webkit-box",
                                        overflow: "hidden",
                                        WebkitBoxOrient: "vertical",
                                        WebkitLineClamp: 2,
                                        scale: 10,
                                        fontSize: HINT_FONT_SIZE
                                    }}
                                >
                                    <b>Location:</b> {locationName}
                                </Typography>
                            )}
                            {propertyName && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        wordWrap: "break-word",
                                        display: "-webkit-box",
                                        overflow: "hidden",
                                        WebkitBoxOrient: "vertical",
                                        WebkitLineClamp: 2,
                                        scale: 10,
                                        fontSize: HINT_FONT_SIZE
                                    }}
                                >
                                    <b>Property:</b> {propertyName}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default QRCodeWithHint;